import React from "react";
import { Row, Col,Card,CardBody,CardHeader } from "reactstrap";
import "./vista-inicio.view.scss";
import { NavLink } from "react-router-dom";
import Tematicas from "../../commons/tematicas.module";
import "./vista-inicio-tematicas.scss";
const LISTA_TEMATICAS = Tematicas.getList();
class VistaTematicas extends React.Component {
  constructor(props) {
    super(props);
    let me = this;
    me.state = {
      active: "",
    };
    me.onImageMouseOver = me.onImageMouseOver.bind(me);
  }
  componentDidMount() {}
  render() {
    let me = this;
    const { active } = this.state;
    return (
      <div>
        <Row>
          <Col>
            <Card>
            <CardHeader>
                <Row>
                  <Col>
                    <div>
                      <h5>Temáticas Ambientales</h5>
                    </div>
                  </Col>
                </Row>
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <Row>
        <Col sm="12" lg="12">
          <div className="vista-inicio-tematica__block-tematicas">
            <div className="vista-inicio__block__body text-center">
              <Row>
                {LISTA_TEMATICAS.map((tematica,key) => {
                  return (
                    <Col key={key} xs={6} sm={4} md={3} xl={3}>
                    <NavLink
                      className=""
                      to={`./tematicas?tematica=${tematica.value}`}
                    >
                        <img
                          src={`imagenes/tematicas/v2/${tematica.value}.png`}
                          alt={tematica.label}
                          onMouseOver={() =>
                            me.onImageMouseOver(tematica.value)
                          }
                          onMouseOut={() => me.onImageMouseOut(tematica.value)}
                          title={"Click para ir a " + tematica.label}
                        />
                        <div className="p ml-2 mr-2">
                          <span className="vista-inicio__block__title"><h6>{tematica.label}</h6></span>
                        </div>
                    </NavLink>
                    </Col>
                  );
                })}
              </Row>
            </div>
            <div className="vista-inicio__block__footer">&nbsp;</div>
          </div>
        </Col>
      </Row>
      </div>
    );
  }
  onImageMouseOver(idTematica) {
    this.setState({ active: idTematica });
  }
  onImageMouseOut() {
    this.setState({ active: "" });
  }
}
export default VistaTematicas;
